// Módulo vacío para reemplazar dependencias no-web en la app web
// Ej.: '@react-native-async-storage/async-storage'
export default {};
module.exports = {};

